<template>
  <div class="article-list">

      <article-list-skeleton v-if="loading" style="margin-bottom: 100vh"></article-list-skeleton>

      <div class="search">
          <van-search v-model="value" @click="$router.push({name:'search'})" @search="onSearch" @clear="onCancel" placeholder="搜一搜"></van-search>
      </div>

      <div class="tags">
          <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
              <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
          </van-tabs>
          <div class="clear"></div>
      </div>

      <div class="swipe">
          <van-swipe :autoplay="3000" indicator-color="#fff">
              <van-swipe-item v-for="item in banners" :key="item.id">
                  <a @click.prevent="toLink(item.target_url)">
                  <!-- <a :href="item.target_url.replace('https://bytx.care-gobroad.com','https://bytx.care-gobroad.com')"> -->
                    <img :src="item.img" alt="">
                  </a>
              </van-swipe-item>
          </van-swipe>
      </div>

      <div class="article-list-section" v-if="list.length > 0">
          <van-row class="article-list-section-box" @click="$router.push({name:'article-detail',params:{'id':item.id}})" v-for="item in list" :key="item.id">
              <div class="article-list-title">{{item.title.length > 34 ? item.title.substr(0,34)+'...' : item.title}}</div>
              <van-col span="16" class="article-list-content">
                  <div class="article-list-content-desc">
                      {{item.desc.length > 26 ? item.desc.substr(0,26)+'...' : item.desc}}
                  </div>
                  <div class="article-list-content-detail">
                      <div>
                          {{item.created_at}}
                          <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                      </div>
                  </div>
              </van-col>
              <van-col span="8">
                  <van-image
                      fit="cover"
                      class="article-list-content-img"
                      :src="item.cover_img"
                      width="100%"
                      height="74"
                  />
              </van-col>
          </van-row>
      </div>
      <div class="van-list__finished-text" v-if="list.length > 6 && page === total_page">已到底部</div>
      <div v-else-if="list.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">查看更多</div>
      <van-empty v-else-if="list.length === 0" description="" image="/static/img/pic_blank_content.svg" >
          <template slot="description">
              <!--<div style="text-align: center">已到底部</div>-->
              <div style="text-align: center">博医同行持续更新中…</div>
              <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
              <div style="text-align: center;margin-top: 24px">
                  <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                      返回首页
                  </van-button>
              </div>
          </template>
      </van-empty>
  </div>
</template>
<script>
    import Interface from "@/util/interface"
    import articleListSkeleton from "@/skeleton/articleListSkeleton"
    import { LocationHref } from '@/util/common'

    export default {
        name: 'article-list',
        components :{
            'article-list-skeleton' : articleListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_child_id:0,
                category_index:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                page:1,
                pageSize:10,
                total_page:1,
            }
        },
        methods: {
            toLink(url){
                const links = url.replace('https://bytx.care-gobroad.com', '')
                LocationHref(links)
            },
            onSearch(){
                this.fetch('article')
            },
            onCancel() {
                this.value = ""
                this.fetch("article")
            },
            fetch(scene) {
                if (scene === 'banner') {
                    Interface.getData('get', Interface.banner, {type: 2}).then((res) => {
                        this.banners = res.data
                        Interface.getShareInfo(this,"前沿资讯——博医同行","","")
                    })
                } else if (scene === 'category') {
                    Interface.getData('get', Interface.category,{type:2}).then((res) => {
                        this.categories = res.data
                        this.categories.unshift({name:"推荐",id:0})
                        if(this.categories.length < 5){
                            for(let i=999;i<= (1007 - this.categories.length);i++){
                                this.categories_child.push({name:"",id:i})
                            }
                        }
                    })
                } else if (scene === 'article') {
                    this.page = 1
                    let params = {
                        page:this.page,
                        pageSize:this.pageSize,
                        category_id : this.category_id,
                    }
                    if(this.value != ""){
                        params.category_id = 0
                        params.title = this.value
                    }
                    Interface.getData('get', Interface.article.list,params).then((res) => {
                        if(res.data.list != null){
                            this.list = res.data.list
                            this.total_page = res.data.total_page
                        }else{
                            this.list = [];
                            this.total_page = 1
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            fetch_more(){
                this.page += 1
                let params = {
                    page : this.page,
                    pageSize:10,
                    category_id : this.category_id,
                }
                Interface.getData('get', Interface.article.list,params).then((res) => {
                    this.list.push(...res.data.list)
                    this.total_page = res.data.total_page
                })
            },
            changeCategory(){
                this.category_id = this.categories[this.category_index].id
                this.fetch('article')
            }
        },
        created() {
            this.fetch('banner')
            this.fetch('category')
            this.fetch('article')
            sessionStorage.removeItem("search_data")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/article/list/index.vue